import React, { useState } from 'react';

/**
 * Barras horizontais com rótulo direto.
 *
 * Horizontal porque o eixo de categorias é nome de doadora e de touro — texto
 * que, na vertical, sai girado ou truncado.
 *
 * Uma série só, então sem legenda: o título já diz o que a barra é.
 *
 * Escala sempre a partir do zero. Barra é comprimento, e comprimento cortado
 * mente sobre a proporção entre os itens.
 */

// Azul da série e o mesmo azul clarinho no trilho. Trilho cinza faria a barra
// parecer flutuar sobre outra coisa; no mesmo tom, ele lê como "o quanto falta".
const COR = '#2a78d6';
const TRILHO = '#e6f0fd';

const BarrasHorizontais = ({ dados, sufixo = '', larguraRotulo = 'w-36', detalhe }) => {
  const [ativo, setAtivo] = useState(null);

  if (!dados || dados.length === 0) {
    return <p className="text-sm text-slate-500 py-6 text-center">Sem dados no período.</p>;
  }

  const maximo = Math.max(...dados.map(d => Number(d.valor) || 0), 1);

  return (
    <div className="space-y-2">
      {dados.map((d, i) => {
        const valor = Number(d.valor) || 0;
        // Um fiapo mínimo para o zero não sumir: ausência de barra e barra
        // invisível se confundem, e uma delas é informação.
        const proporcao = valor > 0 ? Math.max((valor / maximo) * 100, 2) : 0;
        const destacado = ativo === d.rotulo;

        return (
          <div
            key={d.rotulo}
            className="relative flex items-center gap-3 group"
            onMouseEnter={() => setAtivo(d.rotulo)}
            onMouseLeave={() => setAtivo(null)}
          >
            <div className={`${larguraRotulo} shrink-0 truncate text-xs text-slate-600`} title={d.rotulo}>
              {d.rotulo}
            </div>

            <div className="flex-1 min-w-0 flex items-center gap-3">
              <div
                className="flex-1 rounded-full h-2.5 overflow-hidden transition-colors"
                style={{ backgroundColor: TRILHO }}
              >
                {/* Ponta arredondada só no fim — o começo é a linha de base, e
                    arredondá-lo faria a barra parecer descolada do zero. */}
                <div
                  className="h-full rounded-r-full transition-[width] duration-300 ease-out"
                  style={{
                    width: `${proporcao}%`,
                    backgroundColor: COR,
                    opacity: destacado ? 1 : 0.92,
                  }}
                />
              </div>

              {/* O valor em cor de texto, nunca na cor da série: o azul claro
                  seria ilegível como texto, e a identidade já vem da barra. */}
              <span className="text-xs tabular-nums text-slate-900 font-semibold w-16 text-right shrink-0">
                {valor.toLocaleString('pt-BR')}{sufixo}
              </span>
            </div>

            {/* Acima da linha, menos na primeira — ali ele sairia por cima do
                cabeçalho do cartão e ficaria cortado. */}
            {destacado && detalhe && detalhe(d) && (
              <div className={`absolute left-0 z-20 pointer-events-none ${
                i === 0 ? 'top-full mt-1' : '-top-1 -translate-y-full'}`}>
                <div className="bg-slate-900 text-white text-xs rounded-lg px-2.5 py-1.5 shadow-lg whitespace-nowrap">
                  {detalhe(d)}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default BarrasHorizontais;
